module.exports = __webpack_public_path__ + "img/hk-bg-light-2.fa8af6fc.jpg";